import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { AuthFetchService } from './fetch-with-auth';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface OrderListItem {
  orderId: number;
  dateCreated: string;
  buyerNickname: string;
  status: string;
  itemsCount: number;
  firstItemTitle: string;
  totalQuantity: number;
  totalAmount: number;
  paidAmount: number;
  packId?: number;
}

export interface OrderListResponse {
  items: OrderListItem[];
  total: number;
}

@Injectable({
  providedIn: 'root'
})
export class OrderService {
  private apiUrl = `${environment.apiUrl}/orders`;
  private authFetch: AuthFetchService;

  constructor(
    private http: HttpClient,
    private router: Router) {
    this.authFetch = new AuthFetchService();  // Instancie a classe AuthFetchService
  }


  // Usando fetch para obter os pedidos
  getOrders(shippingStatus: string, orderId?: any): Promise<any> {
    let url = `${this.apiUrl}?shippingStatus=${shippingStatus}`;

    if (orderId)
      url = `${url}&orderId=${orderId}`;

    return this.authFetch.fetchWithAuth(url)
      .then(response => {
        if (!response.ok) {
          throw new Error('Erro ao buscar pedidos', {
            cause: response
          });
        }
        return response.json();
      })
      .catch(error => {

        if (error.cause && error.cause.status == 401) {
          this.router.navigate(['/login']);
        } else {
          console.error('Erro ao carregar os pedidos:', error);
        }
        return null;  // Retorne null ou uma mensagem de erro
      });
  }


  invoiceAndGetOrder(orderId?: any): Observable<any> {
    const url = `${this.apiUrl}/invoice/${orderId}`;

    return this.http.get(url, { observe: 'response' });
  }

  // Lista (somente leitura) os pedidos do seller por intervalo de data (máx. 7 dias), paginado.
  getOrdersByDateRange(startDate: string, endDate: string, skip: number, limit: number): Observable<OrderListResponse> {
    const url = `${this.apiUrl}/list?startDate=${startDate}&endDate=${endDate}&skip=${skip}&limit=${limit}`;

    return this.http.get<OrderListResponse>(url, { observe: 'response' }).pipe(
      map(response => response.body || { items: [], total: 0 })
    );
  }
}
